import {
  computed,
  inject,
  Injectable,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';
import { MessageStore } from '../api/message/message-store.service';
import { IMessage, IMessageText } from '@web/dtos';

const MAX_AMOUNT_OF_MESSAGES = 3;

@Injectable({ providedIn: 'root' })
export class MessageService {
  private messageTextStore: MessageStore = inject(MessageStore);
  private messages: WritableSignal<IMessage[]> = signal<IMessage[]>([]);

  messagesWithTexts: Signal<IMessage[]> = computed((): IMessage[] => {
    return this.messages()
      .map((m: IMessage): IMessage => {
        m.text = this.messageTextStore
          .messages()
          .filter((mt: IMessageText): boolean => mt.code === m.code)[0];
        return m;
      })
      .slice(0, MAX_AMOUNT_OF_MESSAGES);
  });

  add(message: IMessage): void {
    this.messages.update((msgs: IMessage[]): IMessage[] => [message, ...msgs]);
    if (message.dismissAfterMs) {
      setTimeout((): void => this.remove(message), message.dismissAfterMs);
    }
  }

  remove(message: IMessage): void {
    this.messages.update((msgs: IMessage[]): IMessage[] =>
      msgs.filter((m: IMessage): boolean => m !== message)
    );
  }

  clear(): void {
    this.messages.set([]);
  }
}
